export const trucksData = [
  {
    id: 1,
    name: "Heavy Duty Truck",
    type: "Flatbed",
    capacity: "40 Tons",
    length: "48 ft",
    width: "8.5 ft",
    height: "8 ft",
    features: ["Heavy Load Capacity", "Flatbed Design", "Tarp System", "Tie-down Points"],
    dailyRate: "R 8,500",
    weeklyRate: "R 45,000",
    available: true,
  },
  {
    id: 2,
    name: "Refrigerated Truck",
    type: "Reefer",
    capacity: "26 Tons",
    length: "40 ft",
    width: "8 ft",
    height: "8 ft",
    features: ["Temperature Control", "GPS Tracking", "Side Doors", "Pallet Jack"],
    dailyRate: "R 7,200",
    weeklyRate: "R 38,000",
    available: true,
  },
  {
    id: 3,
    name: "Box Truck",
    type: "Dry Van",
    capacity: "20 Tons",
    length: "32 ft",
    width: "8 ft",
    height: "8.5 ft",
    features: ["Weatherproof", "Roll-up Door", "Lift Gate", "E-tracking"],
    dailyRate: "R 5,800",
    weeklyRate: "R 30,000",
    available: true,
  },
  {
    id: 4,
    name: "Container Carrier",
    type: "Skeletal",
    capacity: "50 Tons",
    length: "53 ft",
    width: "8.5 ft",
    height: "9.5 ft",
    features: ["Container Transport", "Hydraulic System", "Multi-axle", "Advanced Braking"],
    dailyRate: "R 12,000",
    weeklyRate: "R 65,000",
    available: false,
  },
  {
    id: 5,
    name: "Tanker Truck",
    type: "Liquid Transport",
    capacity: "30,000 Liters",
    length: "42 ft",
    width: "8 ft",
    height: "10 ft",
    features: ["Food Grade", "Stainless Steel", "Pumping System", "Safety Valves"],
    dailyRate: "R 9,500",
    weeklyRate: "R 50,000",
    available: true,
  },
  {
    id: 6,
    name: "Curtainsider Truck",
    type: "Side Access",
    capacity: "24 Tons",
    length: "36 ft",
    width: "8 ft",
    height: "8 ft",
    features: ["Full Side Access", "Weather Protection", "Quick Loading", "Pallet Friendly"],
    dailyRate: "R 6,500",
    weeklyRate: "R 34,000",
    available: true,
  },
];